import { Container } from '../utils/commonUtils';
import * as formServices from '../redux/services/formUtilsServices';
const configInState = 'formData';

// The reason all the 'this.props.form' is a passthrough to form services
// is because I do not want to pollute the 'this.props.services' namespace.
export default (formName, FormComponent) => Container({
    services: [ formServices ],
    state: state => ({ [configInState]: state[configInState]})
},
class FormClass extends React.Component {
    state = { key: formName, stateReference: null, constants: null }
    constructor(props) { super(props); }

    componentDidMount() {
        this.createInitState();
    }

    createInitState = () => {
        const 
        { services } = this.props,
        data = this.props[configInState];
        if(!data.hasOwnProperty(formName)) {
            services.addNewFormEntry(formName);
            this.setState({...this.state, stateReference: `this.props.${configInState}.${formName}` });
        }
    }

    generateConstants = () => {
        const 
        { key } = this.state,
        data = this.props[configInState][key];
        let stringMod ='', newConstants = {};

        for(let p in data) {
            if(p.indexOf('-') === -1) newConstants[p.toUpperCase()] = p;
            else {
                let segments = p.split('-');

                for(let s in segments)
                    stringMod += `${segments[s].toUpperCase()}_`;

                newConstants[stringMod.substring(0, stringMod.length - 1)] = p;
                stringMod = '';
            }
        }

        return newConstants;
    }

    static validate = (key, services, field) => services.validateFormField(key, field);
    static config = (key, services, fieldsObj) => services.buildFormConfigFromObject(key, fieldsObj);

    static getValue = (data, field) => data != null && data.hasOwnProperty(field) ? data[field].value : null;
    static setValue = (key, services, field, value) => services.setFieldFormValue(key, field, value);

    static getForm = (data, field) => data != null && data.hasOwnProperty(field) ? data[field].form : null;
    static setForm = (key, services, field, props) => services.setFieldFormProps(key, field, props);

    static getRules = (data, field) => data != null && data.hasOwnProperty(field) ? data[field].rules : null;
    static setRules = (key, services, field, rules) => services.setFieldFormRules(key, field, rules);

    static resetField = (key, services, field) => {};
    static resetForm = (key, services, field) => {};
    static reset = (key, services, field) => {};
    static resetAll = (key, services) => {};

    static getFieldList = data => {
        let fieldSet = new Set();
        if(data != null) {
            for(let f in data)
                fieldSet.add(f);
            return fieldSet;
        } else return null;
    }

    render = () => {
        const 
        { key } = this.state,
        { services } = this.props,
        data = this.props[configInState][key];

        return (<FormComponent {...this.props} 
            key={this.key}
            formConstants={data != null ? this.generateConstants() : null}
            form={{
                validate: field => FormClass.validate(key, services, field),
                config: fieldsObj => FormClass.config(key, services, fieldsObj),

                getValue: field => FormClass.getValue(data, field),
                setValue: (field, value) => FormClass.setValue(key, services, field, value),

                getForm: field => FormClass.getForm(data, field),
                setForm: (field, props) => FormClass.setForm(key, services, field, props),

                getRules: field => FormClass.getRules(data, field),
                setRules: (field, fules) => FormClass.setRules(key, services, field, fules), 

                resetField: field => FormClass.resetField(key, services, field),
                resetForm: field => FormClass.resetForm(key, services, field),
                reset: field => FormClass.reset(key, services, field),
                resetAll: () => FormClass.resetAll(key, services),

                getFieldList: () => FormClass.getFieldList(data)
            }}
        />);
    };
});